export default function useLifecycleCallbacks(callback: () => void | (() => void) | Promise<void | (() => void)>): void {
	let cleanup = () => {};

	onMounted(async () => {
		const resolvedCallback = await callback();

		if (resolvedCallback) {
			cleanup = resolvedCallback;
		}
	});

	onBeforeUnmount(cleanup);
}
